import fetchWith403Redirect from './fetchWith403Redirect';
import { API_URL as API_BASE } from '../config/env';

const API_URL = `${API_BASE}/api/locations`;

async function readJsonOrThrow(res) {
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(body?.message || `Request failed (${res.status})`);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
}

export async function getLocations() {
  try {
    const res = await fetchWith403Redirect(API_URL, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
    const data = await readJsonOrThrow(res);
    return Array.isArray(data) ? data : [];
  } catch (err) {
    return [];
  }
}

export async function addLocation(location) {
  const res = await fetchWith403Redirect(API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    body: JSON.stringify(location)
  });
  return readJsonOrThrow(res);
}

export async function updateLocation(id, location) {
  const res = await fetchWith403Redirect(`${API_URL}/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    body: JSON.stringify(location)
  });
  return readJsonOrThrow(res);
}

export async function deleteLocation(id) {
  const res = await fetchWith403Redirect(`${API_URL}/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });
  return readJsonOrThrow(res);
}
